/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProductionOrdersForTimePeriodEntry } from '../../models/get-production-orders-for-time-period-entry';
import { ProductionOrderData } from '../../models/production-order-data';

export interface GetProductionOrderDetails$Params {
  workCenterId: number;
      body: GetProductionOrdersForTimePeriodEntry
}

export function getProductionOrderDetails(http: HttpClient, rootUrl: string, params: GetProductionOrderDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductionOrderData>>> {
  const rb = new RequestBuilder(rootUrl, getProductionOrderDetails.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProductionOrderData>>;
    })
  );
}

getProductionOrderDetails.PATH = '/api/v1/ProductionOrder/{workCenterId}/GetProductionOrderDetails';
